import { post } from "../api/apiClient";
import LoginRequest from "../form/request/LoginRequest";

const API_PREFIX = "/auth";

export const login = async request => {
  const response = await post(`${API_PREFIX}/login`, new LoginRequest(request));
  console.log("response", response);
  if (response.data.token) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};
